<template>
  <v-app>
    <TheNavBar />

<!--
    <v-navigation-drawer rail
                         expand-on-hover
    >
      <v-list density="compact" nav>
        <v-list-item prepend-icon="mdi-home-city" title="Home" value="home"></v-list-item>
        <v-list-item prepend-icon="mdi-map" title="Metadata" value="map"></v-list-item>
      </v-list>
    </v-navigation-drawer>
-->

    <v-main>
      <RouterView />
    </v-main>

  </v-app>

</template>

<script setup lang="ts">
  import { RouterView } from 'vue-router'
  import TheNavBar from "@/components/TheNavBar.vue";
  import {useMetadataStore} from "@/stores/metadataStore";

  const mStore = useMetadataStore();

  mStore.fetchMetadata()
  mStore.fetchGeoJSON()


</script>


<style scoped>


</style>
